import { render, staticRenderFns } from "./ProcessarTransacaoPagseguro.vue?vue&type=template&id=f060f176"
import script from "./ProcessarTransacaoPagseguro.vue?vue&type=script&lang=ts"
export * from "./ProcessarTransacaoPagseguro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports